import DoctorCard from "./DoctorCard";
export default DoctorCard;